module.exports = __webpack_public_path__ + "static/fonts/Fact-CondensedLight.7fd1cb0.woff";